export default __webpack_public_path__ + "static/media/1015.461f7582.png";